import React, { createContext, useState, useCallback } from 'react';

const ChatUserContext = createContext();

export const ChatUserProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState({
    email: '',
    cellNumber: '',
    medicalAidNumber: '',
    MedicalAidNumber: '',
    MedicalAid: '',
    PatientFirstName: '',
    PatientLastName: '',
    PatientEmail: '',
    PatientDOB: '',
    PatientCellNumber: '',
    PracticeName: '',
    PracticeEmailAddress: '',
    'Practice Number': '',
    PracticeTelephone: '',
  });

  const updateUserInfo = useCallback((updates) => {
    setUserInfo((prev) => ({ ...prev, ...updates }));
  }, []);

  const clearUserInfo = useCallback(() => {
    setUserInfo({
      email: '',
      cellNumber: '',
      medicalAidNumber: '',
      MedicalAidNumber: '',
      MedicalAid: '',
      PatientFirstName: '',
      PatientLastName: '',
      PatientEmail: '',
      PatientDOB: '',
      PatientCellNumber: '',
      PracticeName: '',
      PracticeEmailAddress: '',
      'Practice Number': '',
      PracticeTelephone: '',
    });
  }, []);

  return (
    <ChatUserContext.Provider value={{ userInfo, updateUserInfo, clearUserInfo }}>
      {children}
    </ChatUserContext.Provider>
  );
};

export default ChatUserContext;
